/**
 * A store's handle (the `loot-os-test` of `loot-os-test.myshopify.com`) from whatever a person
 * pastes: the handle, the myshopify domain, or an admin or storefront URL. Null when it is none.
 */
export function parseShopHandle(input: string): string | null {
  const value = input.trim().toLowerCase();
  if (!value) return null;
  const admin = value.match(/admin\.shopify\.com\/store\/([a-z0-9][a-z0-9-]*)/);
  if (admin?.[1]) return admin[1];
  const domain = value.replace(/^https?:\/\//, "").split("/")[0] ?? "";
  const handle = domain.replace(/\.myshopify\.com$/, "");
  return /^[a-z0-9][a-z0-9-]*$/.test(handle) ? handle : null;
}

/** The store's admin home. */
export function shopifyAdminUrl(handle: string): string {
  return `https://admin.shopify.com/store/${handle}`;
}

/**
 * Shopify's install screen for an app on one store: the app's install link, which installs an
 * unlisted app too.
 */
export function shopifyInstallUrl(handle: string, clientId: string): string {
  return `${shopifyAdminUrl(handle)}/oauth/install?client_id=${encodeURIComponent(clientId)}`;
}

/** The app inside the store's admin. */
export function shopifyAppUrl(handle: string, clientId: string): string {
  return `${shopifyAdminUrl(handle)}/apps/${encodeURIComponent(clientId)}`;
}

/** An order's numeric id, the number in its admin URL, from its GraphQL id. */
export function shopifyOrderNumber(orderGid: string): string {
  return orderGid.replace("gid://shopify/Order/", "");
}

/** An order's page in the store's admin, from its GraphQL id. */
export function shopifyOrderAdminUrl(handle: string, orderGid: string): string {
  return `${shopifyAdminUrl(handle)}/orders/${shopifyOrderNumber(orderGid)}`;
}
